import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { sps } from "../../../json/sps";


const Sps = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Subsecretaria de Prestación de Servicios</h1>
          </div>
         
              
        </div>
      </div>
    
       <div className="steps-row">
       {sps.map((item, index) => (
          <div key={index} className="col-12 seccion">
            <h1 className="titulo-seccion"></h1>
            <div className="bloque">
           
             
            <h5 className="mt-3 titulo-bloque">{item.titulo_item_nombre}</h5>
            
            <div className="cuerpo-bloque">
                {item.archivos.map((tram, i) => (
                  <div>
                 
                 
                  <a className={tram.extencion}
                    target="{_blank}"
                    key={i}
                    href={tram.file_item_url}
                  >
                    {tram.file_item_nombre}
                  </a>
                </div>
                ))}
              </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sps;
